module.exports = __webpack_public_path__ + "img/9spades.380757f3.jpg";